import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/edit_24.svg.ts
import { svg } from "lit";
var edit24Svg = svg`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6716_6139)">
    <path d="M17.3863 2.37738C17.6644 2.09921 17.9947 1.87856 18.3581 1.72802C18.7215 1.57748 19.1111 1.5 19.5045 1.5C19.8978 1.5 20.2874 1.57748 20.6508 1.72802C21.0142 1.87856 21.3445 2.09921 21.6226 2.37738C21.9008 2.65554 22.1214 2.98576 22.272 3.3492C22.4225 3.71264 22.5 4.10217 22.5 4.49555C22.5 4.88893 22.4225 5.27846 22.272 5.64189C22.1214 6.00533 21.9008 6.33556 21.6226 6.61372L7.32497 20.9114L1.5 22.5L3.08863 16.675L17.3863 2.37738Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_6139">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>

`;
export {
  edit24Svg
};
//# sourceMappingURL=edit_24.svg-LIXQVG7G.js.map
